import * as React from "react";

import { ChapterArticle } from "../Models/ChapterArticle";

const FeaturedChapter = (props: {
    item: ChapterArticle;
}) => {

    // return
    return <div className="featured-news-card">
        <div className="card-header">Featured Article</div>

        {props.item.Thumbnail && 
            <a href={props.item.Url} className="img-wrap">
                <img className="card-img-top" src={props.item.Thumbnail} alt={props.item.ThumbnailAlt} />
            </a>
        }
        <div className="card-body">
            <div hidden={!props.item.Category}>
                <span className="category-sticker" style={{
                    backgroundColor: props.item.Category ? props.item.Category.BackgroundColor : '',
                    color: props.item.Category ? props.item.Category.TextColor : ''
                }}>
                    {props.item.Category ? props.item.Category.Name : ''}
                </span>
            </div>
            <a className="card-title mb-2" href={props.item.Url} dangerouslySetInnerHTML={{ __html: props.item.Title }}>

            </a>
            <div className="mt-3 mb-1 summary" dangerouslySetInnerHTML={{ __html: props.item.Summary }}>

            </div>
            <div className="mt-3 mb-1 date">
                <span className="author">By <b>{props.item.Author}</b></span>
                <span className="date">{props.item.DateAsString}</span>
            </div>

            <a className="btn btn-primary d-block" href={props.item.Url}>Read Now</a>

            {/*
            <div className="d-flex justify-content-center mt-2">                
                <div className="addthis_toolbox d-inline" data-addthis-url={props.item.Url} data-addthis-title={props.item.Title}>
                    <span className="custom_images">
                        <a className="addthis_button_more"><span className="btn-share">Share</span></a>
                    </span>
                </div>
            </div>
            */}

        </div>
    </div>
}

export default FeaturedChapter;